<template>
	<div>
		<div class="sub-header">
			<div class="sub-header-content">
				<img src="../assets/logo-red.png" class="sub-header-logo">
				<p class="sub-header-row">
					<span>药食同源</span>
					<span>康养食品</span>
				</p>
				<p class="sub-header-title">{{title}}</p>
				<div class="header-rightsidebar">
					<div class="process-box" v-if="!hide">
						<div class="process-item active">
							<div class="circle-row">
								1
							</div>
							我的购物车
						</div>
						<div class="process-item active">
							<div class="circle-row">
								2
							</div>
							填写核对订单信息
						</div>
						<div class="process-item">
							<div class="circle-row">
								3
							</div>
							完成订单
						</div>
					</div>
					<div class="process-box" v-if="!hide2">
						<div class="process-item active">
							<div class="circle-row">
								1
							</div>
							商品详情
						</div>
						<div class="process-item active">
							<div class="circle-row">
								2
							</div>
							填写核对订单信息
						</div>
						<div class="process-item">
							<div class="circle-row">
								3
							</div>
							完成订单
						</div>
					</div>
					<div style="width: 375px;" v-if="!hideAlert">
						<el-alert title="限时30元购物券免费领，一人一次限领一张~" type="warning">
						</el-alert>
					</div>
					<div class="step-wrap" v-if="hideStep">
						<ul class="step-list">
							<li :class="{gray: stepNum < 1}">
								<span class="circle-num">1</span>
								买家申请退款退货
							</li>
							<li :class="{gray: stepNum < 2}">
								<span class="circle-num">2</span>
								卖家处理退款申请
							</li>
							<li :class="{gray: stepNum < 3}">
								<span class="circle-num">3</span>
								买家退货
							</li>
							<li :class="{gray: stepNum < 4}">
								<span class="circle-num">4</span>
								退款完成
							</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'Subheader',
		props: {
			// 标题
			title: {
				type: String,
				default: '',
			},
			// 是否隐藏
			hide: {
				type: Boolean,
				default: false,
			},
			// 是否隐藏
			hide2: {
				type: Boolean,
				default: false,
			},
			//是否隐藏提示信息
			hideAlert: {
				type: Boolean,
				default: false,
			},
			//是否步骤信息
			hideStep: {
				type: Boolean,
				default: true,
			},
			stepNum: {
				type: Number,
				default: 1,
			}
		},
		data() {
			return {

			}
		}
	}
</script>

<style scoped>
	.sub-header {
		width: 100%;
		height: 100px;
		display: flex;
		justify-content: center;
		background-color: #FFFFFF;
		position: fixed;
		top: 40px;
		left: 0;
		z-index: 99;
	}

	.sub-header-content {
		width: 1200px;
		height: 100px;
		display: flex;
		align-items: center;
	}

	.sub-header-logo {
		width: 79px;
		margin-right: 7px;
	}

	.sub-header-row {
		display: flex;
		flex-direction: column;
		font-size: 16px;
		color: #F2501A;
		margin-right: 18px;
	}

	.sub-header-title {
		color: #202020;
		font-size: 16px;
	}

	.header-rightsidebar {
		flex: 1;
		display: flex;
		justify-content: flex-end;
		align-items: center;
	}

	.process-box {
		/* width: 343px; */
		display: flex;
		/* 	justify-content: space-between; */
		align-items: center;
	}

	.process-item {
		width: 130px;
		display: flex;
		flex-direction: column;
		align-items: center;
		color: #D8D8D8;
		font-size: 14px;
		position: relative;
	}

	.process-item::after {
		content: "";
		width: 100%;
		height: 1px;
		background-color: #F2F2F2;
		position: absolute;
		right: -50%;
		top: 15px;
		z-index: -1;
	}

	.process-item:last-child::after {
		background-color: initial;
	}

	.circle-row {
		display: flex;
		justify-content: center;
		align-items: center;
		width: 30px;
		height: 30px;
		border-radius: 50%;
		background-color: #D8D8D8;
		color: #FFFFFF;
		font-size: 15px;
		margin-bottom: 6px;
	}

	.process-item.active {
		color: #F2501A;
	}

	.process-item.active .circle-row {
		background-color: #F2501A;
	}

	.step-wrap {
		flex: 1;
		display: flex;
		justify-content: flex-end;
		align-items: center;
	}

	.step-list {
		display: flex;
		align-items: center;
	}

	.step-list>li {
		min-width: 240px;
		height: 30px;
		background-color: #F2501A;
		color: #FFFFFF;
		font-size: 14px;
		display: flex;
		justify-content: center;
		align-items: center;
		position: relative;
	}

	.step-list>li::before {
		content: "";
		display: block;
		position: absolute;
		left: 0;
		top: 50%;
		transform: translate(0, -50%);
		width: 0;
		height: 0;
		border: 15px solid transparent;
		border-left-color: #FFFFFF;
	}

	.step-list>li:first-child::before {
		border-left-color: #F2501A;
	}

	.step-list>li::after {
		content: "";
		display: block;
		position: absolute;
		right: 0;
		top: 50%;
		transform: translate(0, -50%);
		width: 0;
		height: 0;
		border-top: 15px solid #FFFFFF;
		border-bottom: 15px solid #FFFFFF;
		border-left: 15px solid #F2501A;
	}

	.step-list>li:last-child::after {
		border-top: 15px solid #F2501A;
		border-bottom: 15px solid #F2501A;
	}

	.circle-num {
		width: 17px;
		height: 17px;
		line-height: 17px;
		font-size: 12px;
		color: #F2501A;
		border-radius: 50%;
		background-color: #FFFFFF;
		display: flex;
		justify-content: center;
		align-items: center;
		margin-right: 9px;
	}

	.step-list>li.gray {
		color: #BBBBBB !important;
		background-color: #EEEEEE !important;
	}

	.step-list>li.gray .circle-num {
		color: #FFFFFF !important;
		background-color: #BBBBBB !important;
	}

	.step-list>li.gray::before {
		border-left-color: #FFFFFF;
	}

	.step-list>li.gray:first-child::before {
		border-left-color: #EEEEEE;
	}

	.step-list>li.gray::after {
		border-top: 15px solid #FFFFFF;
		border-bottom: 15px solid #FFFFFF;
		border-left: 15px solid #EEEEEE;
	}

	.step-list>li.gray:last-child::after {
		border-top: 15px solid #EEEEEE;
		border-bottom: 15px solid #EEEEEE;
	}
</style>
